<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" id="dados-fisicos-tab" data-toggle="tab" href="#dados-fisicos" role="tab"
      aria-controls="dados-fisicos" aria-selected="true">Dados físicos</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="corpo-tecnico-tab" data-toggle="tab" href="#corpo-tecnico" role="tab"
      aria-controls="corpo-tecnico" aria-selected="true">Corpo Técnico</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="conferencia-tab" data-toggle="tab" href="#conferencia" role="tab"
      aria-controls="conferencia" aria-selected="true">Conferência / Medição</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="dados-financeiros-tab" data-toggle="tab" href="#dados-financeiros" role="tab"
      aria-controls="dados-financeiros" aria-selected="true">Dados financeiros</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane fade show active" id="dados-fisicos" role="tabpanel" aria-labelledby="dados-fisicos-tab">
    <p-fieldset legend="Dados da Execução">
      <div class="row col-form-label">
        <label class="required float-left col-6">
          Situação do ajuste
        </label>
        <select [compareWith]="compareFn" class="form-control col-4" [(ngModel)]="arquivo.SituacaoDoAjuste"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesSituacaoAjuste" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </div>
      <div class="row col-form-label">
        <label class="required col-6">
          Data de entrega do material ou início da execução de serviço/obra
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.DataDeEntrega" [ngModelOptions]="{standalone: true}"
          inputStyleClass="form-control col-auto" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
          [showButtonBar]="true" [showIcon]="true">
        </p-calendar>
      </div>
      <div class="row col-form-label">
        <label class="required float-left col-6">
          Qual regime de execução ou a forma de fornecimento do objeto contratual?
        </label>
        <p-selectButton [options]="opcoesRegimeContratacao" optionValue="id" class="float-right col-6"
          [(ngModel)]="arquivo.ExecucaoFornecimentoObjetoContratual" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row col-form-label">
        <label class="required float-left col-6">
          Trata-se de objeto decorrente de importação?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.ObjetoDecorrenteImportacao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
    </p-fieldset>
    <p-fieldset legend="Cronograma">
      <div class="row col-form-label">
        <label class="required float-left col-5">
          A execução do contrato está de acordo com o cronograma físico-financeiro ou prazo de entrega pactuado?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-2"
          [(ngModel)]="arquivo.ExecucaoAcordoCronogramaSim" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
        <label class="required float-left col-3" *ngIf="arquivo.ExecucaoAcordoCronogramaSim === 'N'">
          O motivo foi aceito pela administração?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-2"
          [(ngModel)]="arquivo.ExecucaoAcordoCronogramaNao.MotivoAceitoAdministracao"
          [ngModelOptions]="{standalone: true}" *ngIf="arquivo.ExecucaoAcordoCronogramaSim === 'N'">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row" *ngIf="arquivo.ExecucaoAcordoCronogramaSim === 'N'">
        <div class="col-12">
          <label for="AcordoCronogramaNaoMotivo" class="required">Caso negativo, qual o motivo</label>
          <textarea class="form-control" id="AcordoCronogramaNaoMotivo" rows="5"
            [(ngModel)]="arquivo.ExecucaoAcordoCronogramaNao.AcordoCronogramaNaoMotivo"
            [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      </div>
      <div class="row col-form-label">
        <label class="required float-left col-4">
          Em caso de obra pública, ela está paralisada?
        </label>
        <p-selectButton [options]="opcoesSimNaoNaoObra" optionValue="id" class="float-right col-6"
          [(ngModel)]="arquivo.ObraPublicaEstaParalisadaNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row" *ngIf="arquivo.ObraPublicaEstaParalisadaNao === 'S'">
        <div class="col-12">
          <label for="ObraPublicaMotivoParalisacao" class="required">Motivo da paralisação</label>
          <textarea class="form-control" id="ObraPublicaMotivoParalisacao" rows="5"
            [(ngModel)]="arquivo.ObraPublicaEstaParalisadaSim.ObraPublicaMotivoParalisacao"
            [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      </div>
    </p-fieldset>
    <p-fieldset legend="Forma de Recebimento">
      <div class="row col-form-label">
        <label class="required float-left col-4">
          Existe termo circunstanciado assinado pelas partes?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-2"
          [(ngModel)]="arquivo.ExisteTermoAssinadoPelasPartes" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
        <label class="required float-left col-3">
          Forma de recebimento
        </label>
        <p-selectButton [options]="opcoesFormaRecebimento" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.FormaRecebimento" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row col-form-label">
        <label class="required float-left col-4">
          Existe vistoria que comprove a adequação do objeto aos termos contratuais?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-2"
          [(ngModel)]="arquivo.ExisteVistoriaComproveAdequacaoObjeto" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
        <label class="required col-3">
          Data do recebimento
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.FormaRecebimentoDt"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
          dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
        </p-calendar>
      </div>
    </p-fieldset>
    <p-fieldset legend="Inexecução do Contrato">
      <div class="row col-form-label">
        <label class="required float-left col-3">
          Houve inexecução do contrato?
        </label>
        <p-selectButton [options]="opcoesSimNaoParcial" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.InexecucaoNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
        <label class="required col-3" *ngIf="arquivo.InexecucaoNao !== 'N'">
          Data de abertura do procedimento administrativo
        </label>
        <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.Inexecucao.DataAberturaProcedimentoAdministrativo"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
          dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
          *ngIf="arquivo.InexecucaoNao !== 'N'">
        </p-calendar>
      </div>
      <div class="row" *ngIf="arquivo.InexecucaoNao !== 'N'">
        <div class="col-12">
          <label for="InexecucaoMotivo" class="required">Motivo da inexecução do contrato</label>
          <textarea class="form-control" id="InexecucaoMotivo" rows="5"
            [(ngModel)]="arquivo.Inexecucao.InexecucaoMotivo" [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      </div>
      <div class="row col-form-label" *ngIf="arquivo.InexecucaoNao === 'ST'">
        <label class="required float-left col-3">
          Houve Aplicação de Sanções?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.Inexecucao.ExisteAplicacaoSancoes" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
    </p-fieldset>
    <lib-licitacao-audesp-responsavel [execucao]="arquivo" [campo]="'ResponsavelRecebimento'">
    </lib-licitacao-audesp-responsavel>
  </div>
  <div class="tab-pane fade" id="corpo-tecnico" role="tabpanel" aria-labelledby="corpo-tecnico-tab">
    <p-fieldset legend="Execução Corpo Técnico">
      <div class="row col-form-label">
        <label class="required float-left col-9">
          O objeto da licitação refere-se à prestação de serviços?
        </label>
        <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.PrestacaoServicoNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row col-form-label" *ngIf="arquivo.PrestacaoServicoNao === 'S'">
        <label class="required float-left col-9">
          Houve transferência de serviços da empresa contratada?
        </label>
        <p-selectButton [options]="opcoesSimNA" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.PrestacaoServicoSim.HouveTransferencia" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row col-form-label" *ngIf="arquivo.PrestacaoServicoNao === 'S'">
        <label class="required float-left col-9">
          Em caso de cessão de mão-de-obra, o número de empregados em atividade é aquele estabelecido no Edital e
          Contrato?
        </label>
        <p-selectButton [options]="opcoesSimNA" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.PrestacaoServicoSim.MONumeroEmpregadoEstabelecidoEdital"
          [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row col-form-label" *ngIf="arquivo.PrestacaoServicoNao === 'S'">
        <label class="required float-left col-9">
          Existe algum tipo de controle com referência ao serviço prestado?
        </label>
        <p-selectButton [options]="opcoesSimNA" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.PrestacaoServicoSim.ExisteControleServicoPrestado" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="conferencia" role="tabpanel" aria-labelledby="conferencia-tab">
    <p-fieldset legend="Conferência / Medição">
      <div class="row col-form-label">
        <label class="required float-left col-3">
          Houve conferência / medição?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.ConferenciaMedicaoNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <div class="row mt-3" *ngIf="arquivo.ConferenciaMedicaoNao === 'S'">
        <div class="col-md-3" *ngIf="!entidade.id">
          <label class="required">Empenho</label>
          <select [compareWith]="compareFn" class="form-control" [(ngModel)]="arquivo.empenhoId"
            [ngModelOptions]="{standalone: true}" (change)="atribuirEmpenho()">
            <option *ngFor="let item of listaEmpenho" [ngValue]="item.id">
              {{item.numero}}/{{item.exercicio.ano}} - {{item.valor_empenho | number : '1.2-2'}}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label for="NumeroMedicao" class="required">Número da medição</label>
          <input type="text" class="form-control" id="NumeroMedicao"
            [(ngModel)]="arquivo.ConferenciaMedicaoSim.NumeroMedicao" [ngModelOptions]="{standalone: true}"
            unmask="typed" [imask]="imaskQtd">
        </div>
        <div class="col-md-2">
          <label for="PercentualExecucao" class="required">Percentual executado</label>
          <input type="text" class="form-control" id="PercentualExecucao"
            [(ngModel)]="arquivo.ConferenciaMedicaoSim.PercentualExecucao" [ngModelOptions]="{standalone: true}"
            unmask="typed" [imask]="imaskConfig">
        </div>
        <div class="col-md-2">
          <label for="ConferenciaDt" class="required">Data da medição</label>
          <p-calendar (onFocus)="onFocusDate()" id="ConferenciaDt"
            [(ngModel)]="arquivo.ConferenciaMedicaoSim.ConferenciaDt" [ngModelOptions]="{standalone: true}"
            inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
            [showButtonBar]="true" [showIcon]="true">
          </p-calendar>
        </div>
        <div class="col-md-3">
          <label class="required">
            Houve supressão de obra?
          </label>
          <p-selectButton [options]="opcoesSimNA" optionValue="id" class="col-12"
            [(ngModel)]="arquivo.ConferenciaMedicaoSim.HouveSupressaoObraBensServico"
            [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
      </div>
      <lib-licitacao-audesp-responsavel [execucao]="arquivo.ConferenciaMedicaoSim"
        [campo]="'ResponsavelRecebimentoMedicaoTI'" *ngIf="arquivo.ConferenciaMedicaoNao === 'S'">
      </lib-licitacao-audesp-responsavel>
    </p-fieldset>
  </div>
  <div class="tab-pane fade" id="dados-financeiros" role="tabpanel" aria-labelledby="dados-financeiros-tab">
    <p-fieldset legend="Data da liquidação">
      <div class="row col-form-label">
        <label class="required float-left col-auto">
          Houve liquidação ou documento similar?
        </label>
        <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
          [(ngModel)]="arquivo.LiquidacaoDocSimilarNao" [ngModelOptions]="{standalone: true}">
          <ng-template let-opcao>
            <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
          </ng-template>
        </p-selectButton>
      </div>
      <lib-licitacao-audesp-liquidacao [execucao]="arquivo" *ngIf="arquivo.LiquidacaoDocSimilarNao === 'S'">
      </lib-licitacao-audesp-liquidacao>
    </p-fieldset>
  </div>
</div>